import { render, staticRenderFns } from "./MnemonicsModal.vue?vue&type=template&id=34c81345&"
import script from "./MnemonicsModal.vue?vue&type=script&lang=js&"
export * from "./MnemonicsModal.vue?vue&type=script&lang=js&"
import style0 from "./MnemonicsModal.vue?vue&type=style&index=0&id=34c81345&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports